import React from "react";
import { ExpandableSportCategoryMenuItem } from "../ExpandableSportCategoryMenuItem";
import { MenuItem } from "../MenuItem";
import PropTypes from "prop-types";
import { TrackingInfo } from "../../tracking/TrackingInfoMenu";

const MenuItemList = props => {
  const { items, component, termKeyPrefix, onClick } = props;

  const getAutomationId = (termKey, termKeyPrefix) => {
    if (termKey?.startsWith(termKeyPrefix)) {
      return termKey;
    }
    return [termKeyPrefix, termKey].filter(elem => !!elem).join("-");
  };

  return (
    <ul className={"menu-item-list"}>
      {items.map(childItem => {
        const hasChildren = childItem.items?.length > 0;
        const Component = hasChildren
          ? ExpandableSportCategoryMenuItem
          : component || MenuItem;

        const automationId = getAutomationId(childItem.termKey, termKeyPrefix);
        return (
          <Component
            key={`menu-item-${automationId}`}
            automationId={automationId}
            item={childItem}
            trackingInfo={TrackingInfo}
            onClick={onClick}
            isChildItem={!hasChildren}
          />
        );
      })}
    </ul>
  );
};

MenuItemList.propTypes = {
  items: PropTypes.array,
  component: PropTypes.func,
  termKeyPrefix: PropTypes.string,
  onClick: PropTypes.func
};

export default MenuItemList;
